export const PERMISSIONS = {
  NL_CRM_PROPOSAL_C: "NL_CRM_PROPOSAL_C",
  NL_CRM_PROPOSAL_U: "NL_CRM_PROPOSAL_U",
  NL_CRM_PROPOSAL_D: "NL_CRM_PROPOSAL_D",
  NL_CRM_PROPOSAL_R: "NL_CRM_PROPOSAL_R",
  NL_CRM_PROPOSAL_L: "NL_CRM_PROPOSAL_L",
  NL_CRM_PROPOSAL_U_ST: "NL_CRM_PROPOSAL_U_ST",
  NL_CRM_LEADS_R: "NL_CRM_LEADS_R",
  NL_CRM_LEADS_C: "NL_CRM_LEADS_C",
  NL_CRM_LEADS_U: "NL_CRM_LEADS_U",
  NL_CRM_LEADS_D: "NL_CRM_LEADS_D",
  NL_CRM_LEADS_L: "NL_CRM_LEADS_L",
  NL_CRM_LEADS_U_ST: "NL_CRM_LEADS_U_ST",
  NL_CRM_FOLLOW_UPS_R: "NL_CRM_FOLLOW_UPS_R",
  NL_CRM_FOLLOW_UPS_C: "NL_CRM_FOLLOW_UPS_C",
  NL_CRM_FOLLOW_UPS_U: "NL_CRM_FOLLOW_UPS_U",
  NL_CRM_FOLLOW_UPS_D: "NL_CRM_FOLLOW_UPS_D",
  NL_CRM_FOLLOW_UPS_L: "NL_CRM_FOLLOW_UPS_L",
  NL_CRM_FOLLOW_UPS_U_ST: "NL_CRM_FOLLOW_UPS_U_ST",
  NL_CRM_LIFE_STAGES_R: "NL_CRM_LIFE_STAGES_R",
  NL_CRM_LIFE_STAGES_C: "NL_CRM_LIFE_STAGES_C",
  NL_CRM_LIFE_STAGES_U: "NL_CRM_LIFE_STAGES_U",
  NL_CRM_LIFE_STAGES_D: "NL_CRM_LIFE_STAGES_D",
  NL_CRM_LIFE_STAGES_L: "NL_CRM_LIFE_STAGES_L",
  NL_CRM_LIFE_STAGES_U_ST: "NL_CRM_LIFE_STAGES_U_ST",
  NL_CRM_SOURCES_R: "NL_CRM_SOURCES_R",
  NL_CRM_SOURCES_C: "NL_CRM_SOURCES_C",
  NL_CRM_SOURCES_U: "NL_CRM_SOURCES_U",
  NL_CRM_SOURCES_D: "NL_CRM_SOURCES_D",
  NL_CRM_SOURCES_L: "NL_CRM_SOURCES_L",
  NL_CRM_SOURCES_U_ST: "NL_CRM_SOURCES_U_ST",
  NL_CRM_CUSTOMERS_R: "NL_CRM_CUSTOMERS_R",
  NL_CRM_CUSTOMERS_C: "NL_CRM_CUSTOMERS_C",
  NL_CRM_CUSTOMERS_U: "NL_CRM_CUSTOMERS_U",
  NL_CRM_CUSTOMERS_D: "NL_CRM_CUSTOMERS_D",
  NL_CRM_CUSTOMERS_L: "NL_CRM_CUSTOMERS_L",
  NL_CRM_CUSTOMERS_U_ST: "NL_CRM_CUSTOMERS_U_ST",
  NL_CRM_SUPPLIERS_R: "NL_CRM_SUPPLIERS_R",
  NL_CRM_SUPPLIERS_C: "NL_CRM_SUPPLIERS_C",
  NL_CRM_SUPPLIERS_U: "NL_CRM_SUPPLIERS_U",
  NL_CRM_SUPPLIERS_D: "NL_CRM_SUPPLIERS_D",
  NL_CRM_SUPPLIERS_L: "NL_CRM_SUPPLIERS_L",
  NL_CRM_SUPPLIERS_U_ST: "NL_CRM_SUPPLIERS_U_ST",
  NL_CRM_SURVEY_R: "NL_CRM_SURVEY_R",
  NL_CRM_SURVEY_C: "NL_CRM_SURVEY_C",
  NL_CRM_SURVEY_U: "NL_CRM_SURVEY_U",
  NL_CRM_SURVEY_D: "NL_CRM_SURVEY_D",
  NL_CRM_SURVEY_L: "NL_CRM_SURVEY_L",
  NL_CRM_SURVEY_U_ST: "NL_CRM_SURVEY_U_ST",
  NL_CRM_PROPOSAL_TEMPLATE_R: "NL_CRM_PROPOSAL_TEMPLATE_R",
  NL_CRM_PROPOSAL_TEMPLATE_C: "NL_CRM_PROPOSAL_TEMPLATE_C",
  NL_CRM_PROPOSAL_TEMPLATE_U: "NL_CRM_PROPOSAL_TEMPLATE_U",
  NL_CRM_PROPOSAL_TEMPLATE_D: "NL_CRM_PROPOSAL_TEMPLATE_D",
  NL_CRM_PROPOSAL_TEMPLATE_L: "NL_CRM_PROPOSAL_TEMPLATE_L",
  NL_CRM_PROPOSAL_TEMPLATE_U_ST: "NL_CRM_PROPOSAL_TEMPLATE_U_ST",
  NL_ATTENDANCE_R: 'NL_ATTENDANCE_R',
  NL_PROJECT_JOB_QUOTATION_C: 'NL_PROJECT_JOB_QUOTATION_C',
  NL_PROJECT_JOB_QUOTATION_R: 'NL_PROJECT_JOB_QUOTATION_R',
  NL_PROJECT_JOB_QUOTATION_U: 'NL_PROJECT_JOB_QUOTATION_U',
  NL_PROJECT_JOB_QUOTATION_D: 'NL_PROJECT_JOB_QUOTATION_D',
  NL_PROJECT_JOB_QUOTATION_L: 'NL_PROJECT_JOB_QUOTATION_L',
  NL_PROJECT_JOB_QUOTATION_U_ST: 'NL_PROJECT_JOB_QUOTATIONS_U_ST',
  NL_ACCOUNTING_QUOTATION_R: 'NL_ACCOUNTING_QUOTATION_R',
  NL_ACCOUNTING_QUOTATION_C: 'NL_ACCOUNTING_QUOTATION_C',
  NL_ACCOUNTING_QUOTATION_U: 'NL_ACCOUNTING_QUOTATION_U', 
  NL_ACCOUNTING_QUOTATION_D: 'NL_ACCOUNTING_QUOTATION_D',
  NL_ACCOUNTING_QUOTATION_L: 'NL_ACCOUNTING_QUOTATION_L',
  NL_ACCOUNTING_QUOTATION_U_ST: 'NL_ACCOUNTING_QUOTATION_U_ST',
  NL_ACCOUNTING_INVOICES_R: 'NL_ACCOUNTING_INVOICES_R',
  NL_ACCOUNTING_INVOICES_C: 'NL_ACCOUNTING_INVOICES_C',
  NL_ACCOUNTING_INVOICES_U: 'NL_ACCOUNTING_INVOICES_U',
  NL_ACCOUNTING_INVOICES_D: 'NL_ACCOUNTING_INVOICES_D',
  NL_ACCOUNTING_INVOICES_L: 'NL_ACCOUNTING_INVOICES_L',
  NL_ACCOUNTING_INVOICES_U_ST: 'NL_ACCOUNTING_INVOICES_U_ST',
  NL_ACCOUNTING_PURCHASES_R: 'NL_ACCOUNTING_PURCHASES_R',
  NL_ACCOUNTING_PURCHASES_C: 'NL_ACCOUNTING_PURCHASES_C',
  NL_ACCOUNTING_PURCHASES_U: 'NL_ACCOUNTING_PURCHASES_U',
  NL_ACCOUNTING_PURCHASES_D: 'NL_ACCOUNTING_PURCHASES_D',
  NL_ACCOUNTING_PURCHASES_L: 'NL_ACCOUNTING_PURCHASES_L',
  NL_ACCOUNTING_PURCHASES_U_ST: 'NL_ACCOUNTING_PURCHASES_U_ST',
  NL_PROJECT_PAYMENTS_R: 'NL_PROJECT_PAYMENTS_R',
  NL_PROJECT_PAYMENTS_C: 'NL_PROJECT_PAYMENTS_C',
  NL_PROJECT_PAYMENTS_U: 'NL_PROJECT_PAYMENTS_U',
  NL_PROJECT_PAYMENTS_D: 'NL_PROJECT_PAYMENTS_D',
  NL_PROJECT_PAYMENTS_L: 'NL_PROJECT_PAYMENTS_L',
  NL_PROJECT_PAYMENTS_U_ST: 'NL_PROJECT_PAYMENTS_U_ST',
  NL_SETTING_ROLES_ACCESS_R: 'NL_SETTING_ROLES_ACCESS_R',
  NL_SETTING_ROLES_ACCESS_C: 'NL_SETTING_ROLES_ACCESS_C',
  NL_SETTING_ROLES_ACCESS_U: 'NL_SETTING_ROLES_ACCESS_U',
  NL_SETTING_ROLES_ACCESS_D: 'NL_SETTING_ROLES_ACCESS_D',
  NL_SETTING_ROLES_ACCESS_L: 'NL_SETTING_ROLES_ACCESS_L',
  NL_SETTING_ROLES_ACCESS_U_ST: 'NL_SETTING_ROLES_ACCESS_U_ST',
  NL_ATTENDANCE_ATTENDANCE_R: 'NL_ATTENDANCE_ATTENDANCE_R',
  NL_ATTENDANCE_ATTENDANCE_C: 'NL_ATTENDANCE_ATTENDANCE_C',
  NL_ATTENDANCE_ATTENDANCE_U: 'NL_ATTENDANCE_ATTENDANCE_U',
  NL_ATTENDANCE_ATTENDANCE_D: 'NL_ATTENDANCE_ATTENDANCE_D',
  NL_ATTENDANCE_ATTENDANCE_L: 'NL_ATTENDANCE_ATTENDANCE_L',
  NL_ATTENDANCE_ATTENDANCE_U_ST: 'NL_ATTENDANCE_ATTENDANCE_U_ST',
  NL_SETTING_R: 'NL_SETTING_R',
  NL_SETTING_BUSINESS_R: 'NL_SETTING_BUSINESS_R',
  NL_SETTING_BUSINESS_C: 'NL_SETTING_BUSINESS_C',
  NL_SETTING_BUSINESS_U: 'NL_SETTING_BUSINESS_U',
  NL_SETTING_BUSINESS_D: 'NL_SETTING_BUSINESS_D',
  NL_SETTING_BUSINESS_L: 'NL_SETTING_BUSINESS_L',
  NL_SETTING_BUSINESS_U_ST: 'NL_SETTING_BUSINESS_U_ST',
  NL_ACCOUNTING_VAT_R: 'NL_ACCOUNTING_VAT_R',
  NL_ACCOUNTING_VAT_C: 'NL_ACCOUNTING_VAT_C',
  NL_ACCOUNTING_VAT_U: 'NL_ACCOUNTING_VAT_U',
  NL_ACCOUNTING_VAT_D: 'NL_ACCOUNTING_VAT_D',
  NL_ACCOUNTING_VAT_L: 'NL_ACCOUNTING_VAT_L',
  NL_ACCOUNTING_VAT_U_ST: 'NL_ACCOUNTING_VAT_U_ST',
  NL_ACCOUNTING_ASSETS_R: 'NL_ACCOUNTING_ASSETS_R',
  NL_ACCOUNTING_ASSETS_C: 'NL_ACCOUNTING_ASSETS_C',
  NL_ACCOUNTING_ASSETS_U: 'NL_ACCOUNTING_ASSETS_U',
  NL_ACCOUNTING_ASSETS_D: 'NL_ACCOUNTING_ASSETS_D',
  NL_ACCOUNTING_ASSETS_L: 'NL_ACCOUNTING_ASSETS_L',
  NL_ACCOUNTING_ASSETS_U_ST: 'NL_ACCOUNTING_ASSETS_U_ST',
  NL_PROJECT_R: 'NL_PROJECT_R',
  NL_PROFILE_R: 'NL_PROFILE_R',
  NL_PROFILE_MY_ATTENDANCE_R: 'NL_PROFILE_MY_ATTENDANCE_R',
  NL_PROFILE_MY_ATTENDANCE_U: 'NL_PROFILE_MY_ATTENDANCE_U',
  NL_PROFILE_MY_TASKS_R: 'NL_PROFILE_MY_TASKS_R',
  NL_PROFILE_MY_TASKS_C: 'NL_PROFILE_MY_TASKS_C',
  NL_PROFILE_MY_TASKS_U: 'NL_PROFILE_MY_TASKS_U',
  NL_PROFILE_MY_TASKS_D: 'NL_PROFILE_MY_TASKS_D',
  NL_PROFILE_MY_TASKS_L: 'NL_PROFILE_MY_TASKS_L',
  NL_PROFILE_MY_FOLLOW_UP_R: 'NL_PROFILE_MY_FOLLOW_UP_R',
  NL_PROFILE_MY_FOLLOW_UP_C: 'NL_PROFILE_MY_FOLLOW_UP_C',
  NL_PROFILE_MY_FOLLOW_UP_U: 'NL_PROFILE_MY_FOLLOW_UP_U',
  NL_PROFILE_MY_FOLLOW_UP_D: 'NL_PROFILE_MY_FOLLOW_UP_D',
  NL_PROFILE_MY_FOLLOW_UP_L: 'NL_PROFILE_MY_FOLLOW_UP_L',
  NL_PROFILE_MY_EXPENSES_R: 'NL_PROFILE_MY_EXPENSES_R',
  NL_PROFILE_MY_EXPENSES_C: 'NL_PROFILE_MY_EXPENSES_C',
  NL_PROFILE_MY_EXPENSES_U: 'NL_PROFILE_MY_EXPENSES_U',
  NL_PROFILE_MY_EXPENSES_D: 'NL_PROFILE_MY_EXPENSES_D',
  NL_PROFILE_MY_EXPENSES_L: 'NL_PROFILE_MY_EXPENSES_L',
  NL_ACCOUNTING_ADMIN_EXPENSES_R: 'NL_ACCOUNTING_ADMIN_EXPENSES_R',
  NL_ACCOUNTING_ADMIN_EXPENSES_C: 'NL_ACCOUNTING_ADMIN_EXPENSES_C',
  NL_ACCOUNTING_ADMIN_EXPENSES_U: 'NL_ACCOUNTING_ADMIN_EXPENSES_U',
  NL_ACCOUNTING_ADMIN_EXPENSES_D: 'NL_ACCOUNTING_ADMIN_EXPENSES_D',
  NL_ACCOUNTING_ADMIN_EXPENSES_L: 'NL_ACCOUNTING_ADMIN_EXPENSES_L',
  NL_ACCOUNTING_ADMIN_EXPENSES_U_ST: 'NL_ACCOUNTING_ADMIN_EXPENSES_U_ST',
  NL_PROFILE_MY_LEAVES_R: 'NL_PROFILE_MY_LEAVES_R',
  NL_PROFILE_MY_LEAVES_C: 'NL_PROFILE_MY_LEAVES_C',
  NL_PROFILE_MY_LEAVES_U: 'NL_PROFILE_MY_LEAVES_U',
  NL_PROFILE_MY_LEAVES_D: 'NL_PROFILE_MY_LEAVES_D',
  NL_PROFILE_MY_LEAVES_L: 'NL_PROFILE_MY_LEAVES_L',
  NL_HR_R:'NL_HR_R',
  NL_HR_DEPARTMENT_R:'NL_HR_DEPARTMENT_R',
  NL_HR_DEPARTMENT_C:'NL_HR_DEPARTMENT_C',
  NL_HR_DEPARTMENT_U:'NL_HR_DEPARTMENT_U',
  NL_HR_DEPARTMENT_D:'NL_HR_DEPARTMENT_D',
  NL_HR_DEPARTMENT_L:'NL_HR_DEPARTMENT_L',
  NL_HR_DEPARTMENT_U_ST:'NL_HR_DEPARTMENT_U_ST',
  NL_HR_EMPLOYEES_R:'NL_HR_EMPLOYEES_R',
  NL_HR_EMPLOYEES_C:'NL_HR_EMPLOYEES_C',
  NL_HR_EMPLOYEES_U:'NL_HR_EMPLOYEES_U',
  NL_HR_EMPLOYEES_D:'NL_HR_EMPLOYEES_D',
  NL_HR_EMPLOYEES_L:'NL_HR_EMPLOYEES_L',
  NL_HR_EMPLOYEES_U_ST:'NL_HR_EMPLOYEES_U_ST',    
  NL_HR_ADMIN_AWARDS_R:'NL_HR_ADMIN_AWARDS_R',
  NL_HR_ADMIN_AWARDS_C:'NL_HR_ADMIN_AWARDS_C',
  NL_HR_ADMIN_AWARDS_U:'NL_HR_ADMIN_AWARDS_U',
  NL_HR_ADMIN_AWARDS_D:'NL_HR_ADMIN_AWARDS_D',
  NL_HR_ADMIN_AWARDS_L:'NL_HR_ADMIN_AWARDS_L',
  NL_HR_ADMIN_AWARDS_U_ST:'NL_HR_ADMIN_AWARDS_U_ST',
  NL_HR_ADMIN_HOLIDAYS_R:'NL_HR_ADMIN_HOLIDAYS_R',
  NL_HR_ADMIN_HOLIDAYS_C:'NL_HR_ADMIN_HOLIDAYS_C',
  NL_HR_ADMIN_HOLIDAYS_U:'NL_HR_ADMIN_HOLIDAYS_U', 
  NL_HR_ADMIN_HOLIDAYS_D:'NL_HR_ADMIN_HOLIDAYS_D',
  NL_HR_ADMIN_HOLIDAYS_L:'NL_HR_ADMIN_HOLIDAYS_L',
  NL_HR_ADMIN_HOLIDAYS_U_ST:'NL_HR_ADMIN_HOLIDAYS_U_ST',
  NL_ATTENDANCE_LEAVE_TYPE_R:'NL_ATTENDANCE_LEAVE_TYPE_R',
  NL_ATTENDANCE_LEAVE_TYPE_C:'NL_ATTENDANCE_LEAVE_TYPE_C',
  NL_ATTENDANCE_LEAVE_TYPE_U:'NL_ATTENDANCE_LEAVE_TYPE_U',
  NL_ATTENDANCE_LEAVE_TYPE_D:'NL_ATTENDANCE_LEAVE_TYPE_D',
  NL_ATTENDANCE_LEAVE_TYPE_L:'NL_ATTENDANCE_LEAVE_TYPE_L',
  NL_ATTENDANCE_LEAVE_TYPE_U_ST:'NL_ATTENDANCE_LEAVE_TYPE_U_ST',
  NL_ATTENDANCE_LEAVE_APPLICATION_R:'NL_ATTENDANCE_LEAVE_APPLICATION_R',
  NL_ATTENDANCE_LEAVE_APPLICATION_C:'NL_ATTENDANCE_LEAVE_APPLICATION_C',
  NL_ATTENDANCE_LEAVE_APPLICATION_U:'NL_ATTENDANCE_LEAVE_APPLICATION_U',
  NL_ATTENDANCE_LEAVE_APPLICATION_D:'NL_ATTENDANCE_LEAVE_APPLICATION_D',
  NL_ATTENDANCE_LEAVE_APPLICATION_L:'NL_ATTENDANCE_LEAVE_APPLICATION_L',
  NL_ATTENDANCE_LEAVE_APPLICATION_U_ST:'NL_ATTENDANCE_LEAVE_APPLICATION_U_ST',
  NL_HR_ADMIN_NOTICE_BOARD_R:'NL_HR_ADMIN_NOTICE_BOARD_R',
  NL_HR_ADMIN_NOTICE_BOARD_C:'NL_HR_ADMIN_NOTICE_BOARD_C',
  NL_HR_ADMIN_NOTICE_BOARD_U:'NL_HR_ADMIN_NOTICE_BOARD_U',
  NL_HR_ADMIN_NOTICE_BOARD_D:'NL_HR_ADMIN_NOTICE_BOARD_D',
  NL_HR_ADMIN_NOTICE_BOARD_L:'NL_HR_ADMIN_NOTICE_BOARD_L',
  NL_HR_ADMIN_NOTICE_BOARD_U_ST:'NL_HR_ADMIN_NOTICE_BOARD_U_ST',
  NL_REPORTS_R: 'NL_REPORTS_R',
  NL_REPORTS_PROJECTS_R: 'NL_REPORTS_PROJECTS_R',
  NL_REPORTS_ACCOUNTS_R: 'NL_REPORTS_ACCOUNTS_R',
  NL_PROJECT_JOB_C: 'NL_PROJECT_JOB_C',
  NL_PROJECT_JOB_U: 'NL_PROJECT_JOB_U',
  NL_PROJECT_JOB_R: 'NL_PROJECT_JOB_R',
  NL_PROJECT_JOB_D: 'NL_PROJECT_JOB_D',
  NL_PROJECT_JOB_L: 'NL_PROJECT_JOB_L',
  NL_PROJECT_JOB_U_ST: 'NL_PROJECT_JOB_U_ST',
  NL_PROJECT_JOB_TASKS_R: 'NL_PROJECT_JOB_TASKS_R',
  NL_PROJECT_JOB_TASKS_C: 'NL_PROJECT_JOB_TASKS_C',
  NL_PROJECT_JOB_TASKS_U: 'NL_PROJECT_JOB_TASKS_U',
  NL_PROJECT_JOB_TASKS_D: 'NL_PROJECT_JOB_TASKS_D',
  NL_PROJECT_JOB_TASKS_L: 'NL_PROJECT_JOB_TASKS_L',
  NL_PROJECT_JOB_TASKS_U_ST: 'NL_PROJECT_JOB_TASKS_U_ST',
  NL_PROJECT_JOB_ORDER_MATERIAL_R: 'NL_PROJECT_JOB_ORDER_MATERIAL_R',
  NL_PROJECT_JOB_ORDER_MATERIAL_C: 'NL_PROJECT_JOB_ORDER_MATERIAL_C',
  NL_PROJECT_JOB_ORDER_MATERIAL_U: 'NL_PROJECT_JOB_ORDER_MATERIAL_U',
  NL_PROJECT_JOB_ORDER_MATERIAL_D: 'NL_PROJECT_JOB_ORDER_MATERIAL_D',
  NL_PROJECT_JOB_ORDER_MATERIAL_L: 'NL_PROJECT_JOB_ORDER_MATERIAL_L',
  NL_PROJECT_JOB_ORDER_MATERIAL_U_ST: 'NL_PROJECT_JOB_ORDER_MATERIAL_U_ST',
  NL_PROJECT_JOB_PURCHASES_R: 'NL_PROJECT_JOB_PURCHASES_R',
  NL_PROJECT_JOB_PURCHASES_C: 'NL_PROJECT_JOB_PURCHASES_C',
  NL_PROJECT_JOB_PURCHASES_U: 'NL_PROJECT_JOB_PURCHASES_U',
  NL_PROJECT_JOB_PURCHASES_D: 'NL_PROJECT_JOB_PURCHASES_D',
  NL_PROJECT_JOB_PURCHASES_L: 'NL_PROJECT_JOB_PURCHASES_L',
  NL_PROJECT_JOB_PURCHASES_U_ST: 'NL_PROJECT_JOB_PURCHASES_U_ST',
  NL_PROJECT_JOB_QUOTATIONS_R: 'NL_PROJECT_JOB_QUOTATIONS_R',
  NL_PROJECT_JOB_QUOTATIONS_C: 'NL_PROJECT_JOB_QUOTATIONS_C',
  NL_PROJECT_JOB_QUOTATIONS_U: 'NL_PROJECT_JOB_QUOTATIONS_U',
  NL_PROJECT_JOB_QUOTATIONS_D: 'NL_PROJECT_JOB_QUOTATIONS_D',
  NL_PROJECT_JOB_QUOTATIONS_L: 'NL_PROJECT_JOB_QUOTATIONS_L',
  NL_PROJECT_JOB_QUOTATIONS_U_ST: 'NL_PROJECT_JOB_QUOTATIONS_U_ST',
  NL_PROJECT_JOB_SNAGGING_R: 'NL_PROJECT_JOB_SNAGGING_R',
  NL_PROJECT_JOB_SNAGGING_C: 'NL_PROJECT_JOB_SNAGGING_C',
  NL_PROJECT_JOB_SNAGGING_U: 'NL_PROJECT_JOB_SNAGGING_U',
  NL_PROJECT_JOB_SNAGGING_D: 'NL_PROJECT_JOB_SNAGGING_D',
  NL_PROJECT_JOB_SNAGGING_L: 'NL_PROJECT_JOB_SNAGGING_L',
  NL_PROJECT_JOB_SNAGGING_U_ST: 'NL_PROJECT_JOB_SNAGGING_U_ST',
  NL_PROJECT_JOB_FEEDBACK_R: 'NL_PROJECT_JOB_FEEDBACK_R',
  NL_PROJECT_JOB_FEEDBACK_C: 'NL_PROJECT_JOB_FEEDBACK_C',
  NL_PROJECT_JOB_FEEDBACK_U: 'NL_PROJECT_JOB_FEEDBACK_U',
  NL_PROJECT_JOB_FEEDBACK_D: 'NL_PROJECT_JOB_FEEDBACK_D',
  NL_PROJECT_JOB_FEEDBACK_L: 'NL_PROJECT_JOB_FEEDBACK_L',
  NL_PROJECT_JOB_FEEDBACK_U_ST: 'NL_PROJECT_JOB_FEEDBACK_U_ST',
  NL_PROJECT_JOB_PAYMENTS_R: 'NL_PROJECT_JOB_PAYMENTS_R',
  NL_PROJECT_JOB_PAYMENTS_C: 'NL_PROJECT_JOB_PAYMENTS_C',
  NL_PROJECT_JOB_PAYMENTS_U: 'NL_PROJECT_JOB_PAYMENTS_U',
  NL_PROJECT_JOB_PAYMENTS_D: 'NL_PROJECT_JOB_PAYMENTS_D',
  NL_PROJECT_JOB_PAYMENTS_L: 'NL_PROJECT_JOB_PAYMENTS_L',
  NL_PROJECT_JOB_PAYMENTS_U_ST: 'NL_PROJECT_JOB_PAYMENTS_U_ST',
} as const;

export type PermissionCode =
  typeof PERMISSIONS[keyof typeof PERMISSIONS];
